

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import api from "@/services/api"
import { namespace, Mutation, Getter } from "vuex-class"
import { LayoutLocations } from "@/types/templateLayout"
import { formatDateMixin } from "@/mixins/formatDateMixin"
import { CurrentUser } from "@/types/user"
import { TenantFeatures } from "@/types/tenantFeatures"
import { ui } from "@/types/ui"

const caseStore = namespace("cases")

@Component({
	components: {
	}
})
export default class CaseFileDisplay extends Vue {
	@Prop()
	file: any;

	@Prop({ type: Boolean, default: true })
	showDescription!: Boolean;

	@Prop({ type: Boolean, default: false })
	viewOnly!: Boolean

	@Prop({ default: null })
	public layout!: LayoutLocations | null;

	@Getter("getMe") public me!: CurrentUser;

	@Prop()
	public ui!:ui;

	@caseStore.Mutation
	public setPreviewFile!: (file: any) => void;

	private deleting = false;

	public get thumbnailStyle () {
		if (this.showPreview && this.hasThumbnail) {
			return {
				"background-image": "url(" + this.thumbnailPath + ")",
				"min-width": "60px",
				"min-height": "67px"
			}
		} else {
			return {}
		}
	}

	public downloadFile (file: any) {
		if (this.deleting) {
			return
		}

		if (this.showPreview) {
			this.setPreviewFile(file)
		} else {
			let downloadUrl = api.baseUrl + "files/download/" + file.id

			let link = document.createElement("a")
			link.href = downloadUrl
			link.download = downloadUrl
			link.click()
		}
	}

	private get showPreview (): boolean {
		const extension = this.extension(this.file.filename).toLowerCase()
		return (extension === "jpg" || extension === "png" || extension === "jpeg" || extension === "mp4" || extension === "mov")
	}

	private get hasThumbnail (): boolean {
		return this.file.thumbnailPath
	}

	private get thumbnailPath (): string {
		return api.baseUrl + "files/download/" + this.file.id + "?thumbnail=true"
	}

	private urlExists (extensionName: string) : boolean {
		var url = "/images/fileicons/" + extensionName + ".svg"

		var http = new XMLHttpRequest()
		http.open("HEAD", url, false)
		http.send()
		return http.status !== 404
	}

	private extension (filename: string): string {
		return filename.substring(filename.lastIndexOf(".") + 1)
	}

	private fileIconExtension (filename: string): string {
		var extensionName = this.extension(filename)

		if (this.urlExists(extensionName)) {
			return extensionName
		} else {
			return "default"
		}
	}

	private fileSize (fileSize: number) {
		if (fileSize < 1024) {
			return fileSize + "B"
		}

		fileSize = Math.round(fileSize / 1024)
		if (fileSize < 1024) {
			return fileSize + "KB"
		}

		fileSize = Math.round(fileSize / 1024)
		return fileSize + "MB"
	}

	public async removeFile () {
		this.$emit("removeFile")
	}

	private get showColumnLayout () {
		return this.layout === LayoutLocations.RightHandMenu && this.me.tenantEnabledFeatures?.includes(TenantFeatures.VerticalSideBarAttachments)
	}

	private displayDateFromISOString (value: string | null) {
		return value ? formatDateMixin.methods.displayDateFromISOString(value, this.$store) : ""
	}

	private get templateView () {
		return {
			"deleting": this.deleting,
			"col-10 m-auto": this.showColumnLayout && (this.ui === ui.old),
			"col-12 m-auto px-0 mx-0": this.showColumnLayout && (this.ui !== ui.old)
		}
	}

	private get detailsView () {
		return {
			"list-group-item-file col-10": !this.showColumnLayout,
			"file-display-column m-b-5": this.showColumnLayout && (this.ui === ui.old),
			"file-display-column m-b-5 col-10 mx-0 px-0": this.showColumnLayout && (this.ui !== ui.old)
		}
	}
	//
	//
}
